"use strict";
'use es6';
/*
  Transforms an `InteractionRecord` to a `LocalInteraction` for local storage.
  Interactions that require more than this should write additional transforms.
*/

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toLocalInteraction = toLocalInteraction;
exports.toInteractionRecord = toInteractionRecord;
var KEYS = ['externalId', 'externalAccountId', 'durationMilliseconds', 'recordingUrl'];

function toLocalInteraction(interactionRecord, localInteraction) {
  return localInteraction.set('call', interactionRecord.metadata.filter(function (__, key) {
    return KEYS.indexOf(key);
  }));
}

function toInteractionRecord(localInteraction, interactionRecord) {
  var metadata = interactionRecord.metadata.merge(localInteraction.get('call'));
  return interactionRecord.set('metadata', metadata);
}